import TextArea from "antd/es/input/TextArea"
import { EmailData } from "~/types/types"
import { t } from "../../../languages/i18n"

interface EmailProps {
  emailData: EmailData
  setEmailData: React.Dispatch<React.SetStateAction<EmailData>>
}
const Email = ({ emailData, setEmailData }: EmailProps) => {
  const handleChange = (field: string, value: string) => {
    setEmailData(prevData => ({
      ...prevData,
      [field]: value,
    }))
  }
  return (
    <div className="flex flex-col w-full border-b">
      <div className="w-full flex flex-row gap-4  pb-8">
        <div className="w-2/5 flex flex-col gap-2 ">
          <h2 className="text-base font-semibold">{t("Contact Email")}</h2>
        </div>
        <div className=" w-3/5 ">
          <TextArea
            onChange={e => handleChange("contactEmail", e.target.value)}
            placeholder={t("Example: contactemail@gmail.com")}
            autoSize={{ minRows: 2, maxRows: 6 }}
            value={emailData.contactEmail}
          />
        </div>
      </div>

      <div className="w-full flex flex-row gap-4 pb-8">
        <div className="w-2/5 flex flex-col gap-2 ">
          <h2 className="text-base font-semibold">{t("Admin Email")}</h2>
        </div>
        <div className=" w-3/5 ">
          <TextArea
            onChange={e => handleChange("adminEmail", e.target.value)}
            placeholder={t("Example: contactemail@gmail.com")}
            autoSize={{ minRows: 2, maxRows: 6 }}
          />
        </div>
      </div>
    </div>
  )
}

export default Email
